import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms'; 
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {NgxPaginationModule} from 'ngx-pagination';

import { AppComponent } from './components/app/app.component'; 
import { NavbarComponent } from './components/navbar/navbar.component';

import { AppRoutingModule} from './app.routing.module';
import { AdminModule } from './modules/admin/admin.module';

import { ApiService } from './services/api.service';
import { UserService } from './services/user.service';
import { CalendarService } from './services/calendar.service';
 
import { CalendarYearDetailDateComponent } from './components/calendar-year-detail-date/calendar-year-detail-date.component';
import { CalendarYearDetailServiceComponent } from './components/calendar-year-detail-service/calendar-year-detail-service.component';
import { CalendarYearDetailNoteComponent } from './components/calendar-year-detail-note/calendar-year-detail-note.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { RegisterConfirmationComponent } from './components/register-confirmation/register-confirmation.component';
import { NotFound404Component } from './components/not-found404/not-found404.component';
import { FooterComponent } from './components/footer/footer.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { CalendarFilterPipe } from './pipes/calendar-filter.pipe'; 
import { CalendarYearV2Component } from './components/calendar-year-v2/calendar-year-v2.component';
import { NavbarCalendarComponent } from './components/navbar-calendar/navbar-calendar.component'; 
import { VestmentColorDisplayComponent } from './components/app/vestment-color-display/vestment-color-display.component';
import { CalendarYearSelectServiceComponent } from './components/calendar-year-select-service/calendar-year-select-service.component'; 
 
import { AppInsightSvc } from './services/appInsights.service'; 
import { GlobalErrorHandler } from './global-error-handler';
import { HttpClientModule } from '@angular/common/http'; 
import { CalendarServiceHolyEucharistFilterPipe } from './pipes/calendar-service-holy-eucharist-filter.pipe';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ResetPasswordSuccessComponent } from './components/reset-password-success/reset-password-success.component';
 import {DbStatusReportsModule} from './modules/db-status-reports/db-status-reports.module';

@NgModule({
  declarations: [
    AppComponent, 
    NavbarComponent,
    NavbarCalendarComponent,
    CalendarFilterPipe,  
    CalendarServiceHolyEucharistFilterPipe,
    CalendarYearDetailDateComponent,
    CalendarYearDetailServiceComponent,
    CalendarYearDetailNoteComponent, 
    CalendarYearSelectServiceComponent,
    CalendarYearV2Component,
    LoginComponent,
    RegisterComponent,
    RegisterConfirmationComponent,
    NotFound404Component,
    FooterComponent,
    CopyrightComponent, 
    VestmentColorDisplayComponent,
    ResetPasswordComponent,
    ResetPasswordSuccessComponent
  ],
  imports: [
    BrowserModule,
    AdminModule,
    AppRoutingModule,
    BrowserAnimationsModule, 
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatTooltipModule,
    FormsModule, 
    HttpClientModule,
    NgxPaginationModule,
  ],
  providers: [
    ApiService,
    UserService,
    CalendarService,
    { provide: AppInsightSvc, useFactory: appInsightsFactory },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  entryComponents: [
    CalendarYearDetailDateComponent,
    CalendarYearDetailServiceComponent,
    CalendarYearSelectServiceComponent,
    CalendarYearDetailNoteComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function appInsightsFactory(): AppInsightSvc {
  console.log("Getting new AppInsightSvc");
   return new AppInsightSvc();
}
